import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import ISubject, { ISubjectInput } from "@/interfaces/subject.interface";
import subjectService from "@/services/subject.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateSubjectProps = {
  formData: ISubjectInput;
} & RequestsProps;

export type Return = {
  create: (props: CreateSubjectProps) => Promise<ISubject>;
} & UseLoadingReturn;

const useCreateSubject = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<ISubjectInput>({
    operation: (formData) => subjectService.create(formData),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, create };
};

export default useCreateSubject;
